import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class HotelService { 

    constructor(private http: HttpClient) { }

    gethotelService() {
        return this.http.get<any[]>(`${environment.apiUrl}get_hotel`);
    }    	    
}
